import React from 'react'
import './active-esim.scss'
import { Link } from 'react-router-dom'

const ActiveEsim = () => {
    return (
        <div className="row">
            <div className="col-lg-6">
                <div className="active-esim-section">
                    <div className="heading">
                        <h2>Active eSim</h2>
                    </div>
                    <div className="esim-wrap">
                        <div className="esim-card">
                            <div className="title">
                                <h5>Japan 3GB Plan</h5>
                                <span>Active</span>
                            </div>
                            <div className="esim-row">
                                <div className="esim-info">
                                    <span>Data Used</span>
                                    <p>1.5GB Of 3GB</p>
                                </div>
                                <div className="esim-info">
                                    <span>Validity Period</span>
                                    <p>10 May - 9 June, 2025</p>
                                </div>
                                <div className="esim-info">
                                    <span>Network</span>
                                    <p>4G/5G</p>
                                </div>
                            </div>
                            <Link to="esims" className='esim-btn'>Manage</Link>
                        </div>
                        <div className="esim-card">
                            <div className="title">
                                <h5>Japan 3GB Plan</h5>
                                <span>Active</span>
                            </div>
                            <div className="esim-row">
                                <div className="esim-info">
                                    <span>Data Used</span>
                                    <p>1.5GB Of 3GB</p>
                                </div>
                                <div className="esim-info">
                                    <span>Validity Period</span>
                                    <p>10 May - 9 June, 2025</p>
                                </div>
                                <div className="esim-info">
                                    <span>Network</span>
                                    <p>4G/5G</p>
                                </div>
                            </div>
                            <Link to="esims" className='esim-btn'>Manage</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-6">
                <div className="active-esim-section">
                    <div className="heading">
                        <h2>Saved Items</h2>
                    </div>
                    <div className="esim-wrap">
                        <div className="esim-card">
                            <div className="title">
                                <h5>Japan 3GB Plan</h5>
                                <span>Active</span>
                            </div>
                            <div className="esim-row">
                                <div className="esim-info">
                                    <span>Data Used</span>
                                    <p>1.5GB Of 3GB</p>
                                </div>
                                <div className="esim-info">
                                    <span>Validity Period</span>
                                    <p>10 May - 9 June, 2025</p>
                                </div>
                                <div className="esim-info">
                                    <span>Network</span>
                                    <p>4G/5G</p>
                                </div>
                            </div>
                            <Link to="esims" className='esim-btn'>Manage</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ActiveEsim